import React, { Component } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import _ from "lodash";
import {
  Button,
  Modal,
  Loading,
  FormItem,
  RadioButton,
  TextArea
} from 'carbon-components-react';
import Select from "react-select";
import Numeral from 'numeral';
import 'numeral/locales/pt-br';
import { NavLink } from 'react-router-dom';
import { Breadcrumb, StepCard, DatePicker, Notification } from '../../../components';
import { pathDmService, getByDmService, getDmService } from '../../../services/Api';
import AjaxSelect from '../../../components/AjaxSelect';
/* import { fifteenBlockRequest } from '../../../utils'; */

class CheckoutAgencia extends Component {
  constructor() {
    super();
    this.state = {
      numeroPedido: '#',
      formaPagamentoOpcional: false,
      dataPrevisaoOpcional: false,
      units: [],
      stores: [],
      list: [],
      diasFechamento: 365,
      horasTriagemCriacao: 0,
      currentDate: "",
      notificationInvalidDate: false,
      equipeSelecionada: { id: 0, nome: "Nenhuma" },
      nomePedido: "",
      logistica: [],
      selectedLogistic: null,
      logisticForm: false,
      showLogistic: false,
      logisticsFieldsOk: true,
      cpfcnpj: "",
      razaonome: "",
      cep: "",
      endereco: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      estado: "",
      cuidados: "",
      telefone: "",
      objLogistica: [],
      showMotivoPrioridade: false,
      motivoPrioridade: "",
      dataPrevisao: "",
      isDigital: false
    };
  }

  componentDidMount = async () => {
    Numeral.locale('pt-br');
    await this.getHoras();
    this.loadUnits();
    this.loadDataFechamento();
    this.getEquipes();
    this.loadLogistics();
    this.verificaItemLogistica();
  };

  getEquipes = async () => {
    try {
      const equipes = await getDmService('/Equipe/GetAtivasFechamentoPedido');
      await this.setState({ equipes: equipes || [] });
    } catch (error) {
      console.log(error);
    }
  }

  getHoras = async () => {
    try {
      const horas = await getDmService('/Pedido/GetHoras');
      await this.setState({ horasTriagemCriacao: horas });
    } catch (error) {
      console.log(error);
    }
  }

  loadDataFechamento = async () => {
    try {
      const data = await getDmService('/Pedido/GetDataFechamento');
      await this.setState({
        diasFechamento: data.horas,
        currentDate: this.getNextValidWorkWeekDay(data.horas),
        dataPrevisao: this.getNextValidWorkWeekDay(data.horas),
        formaPagamentoOpcional: data.formaPagamentoOpcional,
        dataPrevisaoOpcional: data.dataPrevisaoOpcional,
        isDigital: data.isDigital
      });
    } catch (error) {
      console.log(error);
    }
  }

  getNextValidWorkWeekDay = (hours) => {
    const sumHours = this.state.horasTriagemCriacao + hours;
    // const sumHours = hours;
    const qtDias = sumHours / 8;
    const date = moment().add(qtDias.toFixed(), 'days');
    if (date.day() === 6) {
      return moment().add((qtDias + 2).toFixed(), 'days');
    }
    if (date.day() === 0) {
      return moment().add((qtDias + 1).toFixed(), 'days');
    }
    const diff = date.diff(moment(), 'hours');
    if (diff <= 8) {
      return moment().add(1, 'days');
    }
    return date;
  }

  loadUnits = async () => {
    try {
      const data = await getDmService("/Unidade?usaPrecadastro=true");
      this.setState({
        units: data.map(item => ({ id: item.id, label: item.nome }))
      });
    } catch (error) {
      console.error(error);
    }
  };

  loadStores = async unitId => {
    try {
      const data = await getByDmService("/Loja/GetByUnidade", unitId);
      this.setState({
        stores: data.map(item => ({ id: item.id, label: item.nome }))
      });
    } catch (error) {
      console.error(error);
    }
  };

  loadLogistics = async () => {
    const options = [
      { id: 1, label: "Irei retirar o material na DMCard" },
      { id: 2, label: "O material deve ser entregue em outro endereço" }
    ];
    this.setState({ logistica: options });
  };

  verificaItemLogistica = async () => {
    try {
      const data = await getDmService("/Pedido/GetItemLogistica");
      this.setState({ showLogistic: data })
    } catch (error) {
      console.error(error);
    }
  };

  createObjLogistica = () => {
    const obj = {
      CpfCnpj: this.state.cpfcnpj,
      RazaoNome: this.state.razaonome,
      Cep: this.state.cep,
      Endereco: this.state.endereco,
      Numero: this.state.numero,
      Complemento: this.state.complemento,
      Bairro: this.state.bairro,
      Cidade: this.state.cidade,
      Estado: this.state.estado,
      Cuidados: this.state.cuidados,
      Telefone: this.state.telefone
    };
    this.isLogisticsOk();
    this.setState({ objLogistica: obj })
  };

  onsubmit = async e => {
    const {
      custeio,
      formPagamento,
      segmento,
      outroSegmento,
      currentDate,
      list,
      equipeSelecionada,
      nomePedido,
      selectedLogistic,
      objLogistica,
      motivoPrioridade,
      dataPrevisao
    } = this.state;

    e.preventDefault();

    const dataRequest = currentDate.format("MM-YYYY-DD")

    if (e.target.checkValidity()) {
      if (list.length === 0) {
        toast.warn("Você precisa seleconar Unidade e Loja");
        return;
      }

      this.setState({ isSaving: true });
      try {
        const dados = {
          "UnidadesLojas": list,
          custeio: custeio ? custeio.id : 0,
          formPagamento: formPagamento ? formPagamento.id : 0,
          segmento: segmento ? segmento.id : 0,
          outroSegmento,
          DataDesejada: dataRequest,
          DataPrevisaoOriginal: dataPrevisao,
          equipe: equipeSelecionada,
          nomePedido,
          logistica: !!selectedLogistic,
          objLogistica,
          motivoPrioridade
        };
        const resultado = await pathDmService('/Pedido/GeraPedidoAgencia', dados);
        this.setState({ numeroPedido: resultado.codigo }, this.toggleModal);
      } catch (ex) {
        console.log("ex", ex)
        if (ex && ex.code === 400 && ex.message) toast.error(ex.message);
        else toast.error('Ocorreu uma falha ao fechar seu pedido');
      }

      this.setState({ isSaving: false });
    }
  };

  onChangeUnit = obj => {
    this.setState({
      stores: [],
      list: [],
      selectedUnit: obj,
      selectedStore: null,
      error: null
    });

    if (obj) {
      this.loadStores(obj.id);
    }
  };

  onChangeStore = obj => {
    this.setState({ selectedStore: obj, error: null });
  };

  onChangeSegment = (obj) => {
    this.setState({ 'segmento': obj }, () => {
      this.checkSegmentStores();
    });
  };

  checkSegmentStores = () => {
    const { segmento, list } = this.state;
    const validat = true
    const isEdited = (segmento && (list.length > 0)) ? validat : !validat;
    this.setState({ isEdited });
  }

  // onChangeCombo = (obj, name) => {
  //   this.setState({ [name]: obj }, () => {
  //     if (name === 'segmento') {
  //       this.onChangeSegment();
  //     } else {
  //       this.checkExpanded();
  //     }
  //   });
  // };

  // checkExpanded = () => {
  //   const { custeio, formPagamento } = this.state;
  //   const validat = true
  //   const isFinished = (custeio && formPagamento) ? validat : !validat;
  //   this.setState({ isFinished });
  // }

  toggleModal = () => {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
      selectedId: null,
    }));
  };

  onChangeCheck = (val, id, event) => {
    this.setState({ [event.target.name]: val });
  };

  onChangeText = event => {
    this.setState({ [event.target.id]: event.target.value });
  };

  onChangeTextLogistic = async event => {
    await this.setState({ [event.target.name]: event.target.value });
    this.createObjLogistica();
  };

  onDateChange = date => {
    const finished = true;
    const { dataPrevisao } = this.state;
    const showMotivoPrioridade = !(date.format("YYYY/MM/DD") >= dataPrevisao.format("YYYY/MM/DD"));
    this.setState({
      currentDate: date,
      isFinishedDate: finished,
      showMotivoPrioridade,
      notificationInvalidDate: date === null
    });
    // console.log(date)
    //  || this.getNextValidWorkWeekDay(diasFechamento).diff(date, 'days') > 0
    // if (date === null) {
    //   this.setState({
    //     notificationInvalidDate: true
    //   });
    // } else {
    //   this.setState({
    //     notificationInvalidDate: false
    //   });
    // }
  };

  onChangeCheckEquipe = (equipe) => {
    console.log(equipe)
    this.setState({ equipeSelecionada: equipe });
  };

  onChangeLogistica = item => {
    if (!item) {
      this.setState({
        logisticForm: false,
        selectedLogistic: item
      });
    } else if (item.id === 1) {
        this.setState({
          logisticForm: false,
          selectedLogistic: item
        });
      } else {
        this.setState({
          logisticForm: true,
          selectedLogistic: item
        });
      }
    setTimeout(() => this.isLogisticsOk(), 100);
  };

  onChangeTelefone = async event => {
    await this.setState({
      [event.target.name]: this.formatTelefone(event.target.value)
    });
    this.createObjLogistica();
  };

  onChangeCpfCnpj = async event => {
    await this.setState({
      [event.target.name]: this.formatCpfCnpj(event.target.value)
    });
    this.createObjLogistica();
  };

  formatCpfCnpj = inputCpfCnpj => {
    if (!inputCpfCnpj) return inputCpfCnpj;

    let cpfcnpj = inputCpfCnpj;
    if (cpfcnpj.length <= 14) {
      cpfcnpj = cpfcnpj.replace(/\D/g, "");
      // Coloca um ponto entre o terceiro e o quarto dígitos
      cpfcnpj = cpfcnpj.replace(/(\d{3})(\d)/, "$1.$2")

      // Coloca um ponto entre o terceiro e o quarto dígitos
      // de novo (para o segundo bloco de números)
      cpfcnpj = cpfcnpj.replace(/(\d{3})(\d)/, "$1.$2")

      // Coloca um hífen entre o terceiro e o quarto dígitos
      cpfcnpj = cpfcnpj.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    } else {
      cpfcnpj = cpfcnpj.replace(/\D/g, "");
      // Coloca ponto entre o segundo e o terceiro dígitos
      cpfcnpj = cpfcnpj.replace(/^(\d{2})(\d)/, "$1.$2")

      // Coloca ponto entre o quinto e o sexto dígitos
      cpfcnpj = cpfcnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")

      // Coloca uma barra entre o oitavo e o nono dígitos
      cpfcnpj = cpfcnpj.replace(/\.(\d{3})(\d)/, ".$1/$2")

      // Coloca um hífen depois do bloco de quatro dígitos
      cpfcnpj = cpfcnpj.replace(/(\d{4})(\d)/, "$1-$2")
    }

    return cpfcnpj;
  };

  formatTelefone = telefone => {
    if (!telefone) return telefone;

    let fone = telefone;

    fone = fone.replace(/\D/g, "");

    // Coloca parênteses em volta dos dois primeiros dígitos
    fone = fone.replace(/^(\d{2})(\d)/g, "($1) $2");

    // Coloca hífen entre o quarto e o quinto dígitos
    fone = fone.replace(/(\d)(\d{4})$/, "$1-$2");

    return fone;
  }

  buscaCep = event => {
    const cep = event.target.value;

    if (cep.length < 8) {
      this.setState({
        cep,
        endereco: "",
        bairro: "",
        cidade: "",
        estado: ""
      });
      
    } else {
      fetch(`https://viacep.com.br/ws/${cep}/json/`, { mode: 'cors' })
        .then((res) => res.json())
        .then((data) => {
          // eslint-disable-next-line no-prototype-builtins
          if (data.hasOwnProperty("erro")) {
            alert('Cep não existente');
          } else {
            this.setState({
              cep: data.cep,
              endereco: data.logradouro,
              bairro: data.bairro,
              cidade: data.localidade,
              estado: data.uf
            });
          }
        })
        .catch(err => console.log(err));
    }
  };

  removeItem = index => {
    this.setState(prevState => {
      const newList = [...prevState.list];
      newList.splice(index, 1);
      return { list: newList, isEdited: newList.length > 0 };
    });
  };

  addItem = () => {
    const { list, selectedUnit, selectedStore, segmento } = this.state;

    const insertObj = {
      unidade: { id: selectedUnit.id, nome: selectedUnit.label },
      loja: { id: selectedStore.id, nome: selectedStore.label }
    };

    if (_.some(list, obj => _.isEqual(obj, insertObj))) {
      toast.warn("Não é possível adicionar a mesma Unidade e Loja mais de uma vez.");
    } else {

      let segmentoTest = false;

      // eslint-disable-next-line no-unused-expressions
      segmento ? segmentoTest = true : segmentoTest = false;

      this.setState(
        prevState => ({
          list: [...prevState.list, insertObj],
          isEdited: segmentoTest
        })
      );
    }
  };

  isLogisticsOk = () => {    
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.state.selectedLogistic)
      return false;

    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.selectedLogistic.id === 1)
    {
      this.setState( { logisticsFieldsOk: true });
      return true;
    }
          
      // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
      const validLogistics = this.state.razaonome.length > 0 && this.state.cpfcnpj.length > 10 && this.state.cuidados.length > 0 && this.state.cep.length > 0 && this.state.endereco.length > 0 && this.state.numero.length > 0 && this.state.bairro.length > 0 && this.state.cidade.length > 0 && this.state.estado.length > 0 && this.state.telefone.length > 0;
       
       this.setState( { logisticsFieldsOk: validLogistics });

       return validLogistics;
    
  }

  renderList = () => {
    const { list } = this.state;

    return (!list || list.length === 0) ? (
      <Notification
        style={{ width: "100%" }}
        kind="warning"
        title="Atenção: "
        description="Você precisa adicionar uma loja."
      />
    )
      :
      list.map((item, index) => (
        <div
          key={`${item.unidade.id}-${item.loja.id}`}
          className="bx--col-xs-12 bx--col-sm-10"
        >
          <div className="bx--form-item--inline v-sm-margin full-width sm-padding bg-tranlucent">
            <div className="font-size-13 flexible">{item.loja.nome}</div>
            <button
              kind="ghost"
              type="submit"
              className="button button--clear button--icon gray"
              onClick={() => this.removeItem(index)}
            >
              <i className="material-icons">remove_circle</i>
            </button>
          </div>
        </div>
      ));
  };

  renderDescriptionUnitsAndStores = () => {
    const {
      list,
      segmento
    } = this.state;
    if (list.length || segmento) {
      return (
        <div>
          {list.map(item => (
            <p key={`${item.unidade.id} - ${item.loja.id}`}>
              {`${item.unidade.nome} - ${item.loja.nome}`}
            </p>
          ))}
          <p>
            <strong>
              Segmento:&nbsp;
            </strong>
            {segmento ? segmento.label : ""}
          </p>
          {' '}
 
        </div>)
    }
    return (
      <p>
        Selecione para qual Loja este material se destina.
      </p>
    )
  }

  // renderDescriptionPayment = () => {
  //   const {
  //     custeio,
  //     formPagamento
  //   } = this.state;

  //   if (custeio || formPagamento) {
  //     return (
  //       <div>
  //         <p>
  //           <strong>
  //             Custeio:
  //           </strong>
  //           &nbsp;
  //           {custeio ? custeio.label : ""}
  //         </p>
  //         <p>
  //           <strong>
  //             Forma de Pagamento:
  //           </strong>
  //           &nbsp;
  //           {formPagamento ? formPagamento.label : ""}
  //         </p>
  //       </div>
  //     )
  //   }
  //   return (
  //     <p>
  //       Selecione a forma de pagamento que desejar.
  //     </p>
  //   )
  // }

  renderDescriptionDesiredDate = () => {
    const { currentDate, isFinishedDate } = this.state;
    return (
      <p>
        {isFinishedDate && currentDate ?
          (
            <React.Fragment>
              <strong>Data desejada:</strong>
              {` ${currentDate.format("DD/MM/YYYY")}`}
            </React.Fragment>
          )
          :
          null
        }
      </p>
    )
  }

  renderDescriptionLogistica = () => {
    const { selectedLogistic } = this.state;
    return (
      <p>
        {selectedLogistic ? selectedLogistic.label : "Selecione a forma de entrega do material"}
      </p>
    )
  }

  renderDescriptionNomePedido = () => {
    const { nomePedido } = this.state;
    return (
      <p>
        {nomePedido || "Informe um nome para facilitar a sua identificação do pedido. Este nome será usado apenas para facilitar o seu próprio controle."}
      </p>
    )
  }

  renderDescriptionEquipe = () => {
    const { equipeSelecionada } = this.state;
    return (
      <p>
        {equipeSelecionada && equipeSelecionada.id > 0 ? (
          <span>
            <strong>Equipe:</strong>
            {` ${equipeSelecionada.nome}`}
          </span>
        ) : "Selecione uma equipe para compartilhar o pedido (opcional)"}
      </p>
    )
  }

  render() {
    const {
      numeroPedido,
      isSaving,
      openModal,
      isFinishedDate,
      isEdited,
      units,
      stores,
      selectedUnit,
      selectedStore,
      error,
      // custeio,
      // formPagamento,
      segmento,
      currentDate,
      notificationInvalidDate,
      equipes,
      equipeSelecionada,
      // diasFechamento,
      nomePedido,
      // formaPagamentoOpcional,
      dataPrevisaoOpcional,
      logistica,
      selectedLogistic,
      logisticForm,
      showLogistic,
      logisticsFieldsOk,
      cpfcnpj,
      razaonome,
      cep,
      endereco,
      numero,
      complemento,
      bairro,
      cidade,
      estado,
      cuidados,
      telefone,
      showMotivoPrioridade,
      motivoPrioridade,
      isDigital
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title=" Finalizar Pedido de Agência"
          description=" Preencha as Informações abaixo: "
          renderLeft={(() => (
            <div className="breadcrumb-left-actions">
              <NavLink to="/carrinho">
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </NavLink>
            </div>
          ))()}
        />
        <section className="content-wrapper content-wrapper--large">
          <form
            id="form"
            onSubmit={async e => {
              await this.onsubmit(e);
            }}
          >
            <StepCard
              onRef={ref => {
                this.stepCardRef = ref;
              }}
              className="center-box"
              title="Unidade e Loja"
              description={this.renderDescriptionUnitsAndStores()}
              isFinished={isEdited}
              onToggle={isExpanded => isExpanded && this.loadUnits()}
            >
              <div>
                <div className="bx--grid">
                  <div className="bx--row">
                    <div className="bx--col-xs-12 bx--col-sm-4">
                      <label className="v-sm-margin">Unidades</label>
                      <Select
                        className="select-dm"
                        name="units"
                        options={units}
                        value={selectedUnit}
                        onChange={e => this.onChangeUnit(e)}
                        placeholder="Digite o código ou selecione"
                        isClearable={false}
                        isSearchable={false}
                      />
                    </div>
                    <div className="bx--col-xs-12 bx--col-sm-5">
                      <label className="v-sm-margin">Lojas</label>
                      <Select
                        className="select-dm"
                        name="stores"
                        options={stores}
                        value={selectedStore}
                        onChange={e => this.onChangeStore(e)}
                        placeholder="Digite o código ou selecione"
                        isClearable={false}
                        isSearchable={false}
                      />
                    </div>
                    <div className="bx--col-xs-12 bx--col-sm-3">
                      <button
                        kind="ghost"
                        type="button"
                        className="btn-secondary-color bx--btn btn-secondary-color"
                        style={{ height: "35px", marginTop: "30px" }}
                        onClick={this.addItem}
                        disabled={!selectedUnit || !selectedStore}
                      >
                        Adicionar
                      </button>
                    </div>
                  </div>

                  <div className="bx--row" style={{ marginTop: 20, marginLeft: 10 }}>
                    <div className="bx--col-xs-12 bx--col-sm-10">
                      <p>Lojas Adicionadas</p>
                    </div>
                    {this.renderList()}
                  </div>
                  <div className="bx--row">
                    {error && (
                      <div className="bx--col-xs-12 fadeIn animated">
                        <p className="text-danger font-size-12">{error}</p>
                      </div>
                    )}
                  </div>

                  <div className="bx--row">
                    <div className="bx--col-xs-10 bx--col-sm-10">
                      <label className="v-sm-margin">Segmento</label>
                      <AjaxSelect
                        dataService="/Pedido/ListaSegmentos"
                        className="select-dm"
                        name="segmento"
                        value={segmento}
                        onChange={(e) => { this.onChangeSegment(e) }}
                        placeholder="Segmento"
                        isClearable={false}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </StepCard>
            {/* retirado temporariamente
            <div style={{ display: formaPagamentoOpcional ? "none" : "block" }}>
              <StepCard
                onRef={ref => {
                  this.stepCardRef = ref;
                }}
                className="center-box"
                title={`Pagamento ${formaPagamentoOpcional ? " (opcional) " : ""}`}
                description={this.renderDescriptionPayment()}
                isFinished={isFinished}
                onToggle={isExpanded => isExpanded && this.loadUnits()}
              >
                <div>
                  <div className="bx--grid">
                    <div className="bx--row">
                      <div className="bx--col-xs-10 bx--col-sm-10">
                        <label className="v-sm-margin">Custeio</label>
                        <AjaxSelect
                          dataService="/Pedido/ListaCusteios"
                          className="select-dm"
                          name="custeio"
                          value={custeio}
                          onChange={(e) => {
                            this.onChangeCombo(e, 'custeio')
                            if ([2, 3].includes(e.id)) {
                              this.setState({ formPagamento: { id: 2, label: "Desconto no Reembolso" } });
                            } else if ([1].includes(e.id)) {
                              this.setState({ formPagamento: { id: 1, label: "Sem forma de pagamento" } });
                            }
                          }}
                          placeholder="Custeio"
                          isClearable={false}
                          isSearchable={false}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-10 bx--col-sm-10">
                        <label className="v-sm-margin">Forma de Pagamento</label>
                        <AjaxSelect
                          dataService="/Pedido/ListaFormasPagamento"
                          className="select-dm"
                          name="formPagamento"
                          disabled
                          value={formPagamento}
                          onChange={(e) => { this.onChangeCombo(e, 'formPagamento') }}
                          placeholder="Forma de Pagamento"
                          isClearable={false}
                          isSearchable={false}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="bx--row">
                    {error && (
                      <div className="bx--col-xs-12 fadeIn animated">
                        <p className="text-danger font-size-12">{error}</p>
                      </div>
                    )}
                  </div>
                </div>
              </StepCard>
            </div> */}
            <div style={{ display: dataPrevisaoOpcional ? "none" : "block" }}>
              <StepCard
                onRef={ref => {
                  this.stepCardRef = ref;
                }}
                className="center-box"
                title={`Previsão de entrega ${dataPrevisaoOpcional ? " (opcional) " : ""}`}
                description={this.renderDescriptionDesiredDate()}
                isFinished={isFinishedDate && !notificationInvalidDate}
                onToggle={isExpanded => isExpanded && this.loadUnits()}
              >
                {notificationInvalidDate && (
                  <div className="bx--row">
                    <div className="bx--col-md-12 bx--col-xs-12 bx--col-lg-12">
                      <Notification
                        kind="warning"
                        title="Atenção: "
                        description="Informe uma data desejável dentro do prazo permitido."
                      />
                    </div>
                  </div>
                )}

                <div className="bx--row">
                  <div className="bx--col-md-4">
                    <div className="filter-date-agency">
                      <FormItem>
                        <DatePicker
                          date={currentDate ? moment(currentDate) : ""}
                          onDateChange={date => this.onDateChange(date)}
/*                           isDayBlocked={(day) => fifteenBlockRequest(day, diasFechamento)} */
                        />
                      </FormItem>
                    </div>
                  </div>
                </div>
                {showMotivoPrioridade && (
                  <div className="bx--row">
                    <div className="bx--col-md-12">
                      <img className="alert-icon" src={require('../../../assets/images/alert_icon.png')} alt="Alert Icon" />
                      <label className="bx--label">
Justifique o motivo da sua prioridade
                        <br />
* Sujeito à análise
                      </label>
                      <TextArea
                        labelText=""
                        id="motivoPrioridade"
                        value={motivoPrioridade}
                        onChange={e => this.setState({ motivoPrioridade: e.target.value })}
                        rows={1}
                      />
                    </div>
                  </div>
                )}
              </StepCard>
            </div>
            {equipes && equipes.length > 0 && (
              <StepCard
                onRef={ref => {
                  this.stepCardRef = ref;
                }}
                className="center-box"
                title="Equipe"
                description={this.renderDescriptionEquipe()}
                isFinished
              >
                <div className="bx--row">
                  <div className="bx--col-md-4">
                    <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                      <RadioButton
                        name="equipe"
                        className="v-lg-margin"
                        labelText="Nenhuma"
                        checked={equipeSelecionada.id === 0}
                        onClick={() => this.onChangeCheckEquipe({ id: 0, nome: "Nenhuma" })}
                      />
                    </div>
                    {equipes.map(equipe => (
                      <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                        <RadioButton
                          name="equipe"
                          checked={equipeSelecionada.id === equipe.id}
                          className="v-lg-margin"
                          labelText={equipe.nome}
                          onClick={() => this.onChangeCheckEquipe(equipe)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </StepCard>
            )}
            {showLogistic && (
              <StepCard
                onRef={ref => {
                  this.stepCardRef = ref;
                }}
                className="center-box"
                title="Logistica"
                description={this.renderDescriptionLogistica()}
                isFinished={!!selectedLogistic && !!logisticsFieldsOk}
              >
                <div className="bx--row">
                  <div className="bx--col-md-12">
                    <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                      <label className="bx--label">Entrega</label>
                      <Select
                        className="select-dm"
                        name="logistica"
                        options={logistica}
                        value={selectedLogistic}
                        onChange={e => this.onChangeLogistica(e)}
                        placeholder="Selecione a opção desejada"
                        isClearable={false}
                        isSearchable={false}
                      />
                      {logisticForm && (
                        <div>
                          <label className="bx--label">Preencha os dados para entrega</label>
                          <div className="bx--row">
                            <div className="bx--col-xs-6 bx--col-sm-6">
                              <label className="bx--label">Razão social ou Nome Completo (*)</label>
                              <input
                                id="text-input-razao-nome"
                                type="text"
                                className="bx--text-input"
                                name="razaonome"
                                value={razaonome}
                                onChange={e => this.onChangeTextLogistic(e)}
                              />
                              <label className="bx--label">CNPJ ou CPF (*)</label>
                              <input
                                id="text-input-cnpj-cpf"
                                type="text"
                                className="bx--text-input"
                                name="cpfcnpj"
                                value={cpfcnpj}
                                onChange={e => this.onChangeCpfCnpj(e)}
                                maxLength={18}
                              />
                              <label className="bx--label">Nome Completo do responsável pelo recebimento (*)</label>
                              <input
                                id="text-input-cuidados"
                                type="text"
                                className="bx--text-input"
                                name="cuidados"
                                value={cuidados}
                                onChange={e => this.onChangeTextLogistic(e)}
                              />
                              <label className="bx--label">Telefone para contato (*)</label>
                              <input
                                id="text-input-fone"
                                type="text"
                                className="bx--text-input"
                                name="telefone"
                                value={telefone}
                                onChange={e => this.onChangeTelefone(e)}
                                maxLength={15}
                              />
                              <label className="bx--label">CEP (*)</label>
                              <input
                                id="text-input-cep"
                                type="text"
                                className="bx--text-input"
                                name="cep"
                                value={cep}
                                onChange={e => this.buscaCep(e)}
                                maxLength={8}
                              />
                              <label className="bx--label">Endereço (*)</label>
                              <input
                                id="text-input-endereco"
                                type="text"
                                className="bx--text-input"
                                name="endereco"
                                value={endereco}
                                onChange={e => this.onChangeTextLogistic(e)}
                              />
                              <label className="bx--label">Número (*)</label>
                              <input
                                id="text-input-numero"
                                type="text"
                                className="bx--text-input"
                                name="numero"
                                value={numero}
                                onChange={e => this.onChangeTextLogistic(e)}
                              />
                              <label className="bx--label">Complemento</label>
                              <input
                                id="text-input-endereco"
                                type="text"
                                className="bx--text-input"
                                name="complemento"
                                value={complemento}
                                onChange={e => this.onChangeTextLogistic(e)}
                              />
                              <label className="bx--label">Bairro (*)</label>
                              <input
                                id="text-input-bairro"
                                type="text"
                                className="bx--text-input"
                                name="bairro"
                                value={bairro}
                                onChange={e => this.onChangeTextLogistic(e)}
                              />
                              <label className="bx--label">Cidade (*)</label>
                              <input
                                id="text-input-cidade"
                                type="text"
                                className="bx--text-input"
                                name="cidade"
                                value={cidade}
                                onChange={e => this.onChangeTextLogistic(e)}
                              />
                              <label className="bx--label">Estado (*)</label>
                              <input
                                id="text-input-estado"
                                type="text"
                                className="bx--text-input"
                                name="estado"
                                value={estado}
                                onChange={e => this.onChangeTextLogistic(e)}
                              />
                            </div>
                            <div className="bx--col-xs-6 bx--col-sm-6">
                              <div className="bx--col-xs-12 bx--col-sm-12">
                                <p>{razaonome}</p>
                                <p>{cpfcnpj}</p>
                                <p>{`Responsável: ${cuidados}`}</p>
                                <p>{telefone}</p>
                                <p>{`${endereco}, ${numero}`}</p>
                                <p>{complemento}</p>
                                <p>{`${bairro} - ${cidade}/${estado}`}</p>
                                <p>{`CEP: ${cep}`}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </StepCard>
            )}
            <StepCard
              onRef={ref => {
                this.stepCardRef = ref;
              }}
              className="center-box"
              title="Nome do pedido"
              description={this.renderDescriptionNomePedido()}
              isFinished={!!nomePedido}
            >
              <div className="bx--row">
                <div className="bx--col-md-4">
                  <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                    <label className="bx--label">Nome do pedido</label>
                    <input
                      id="text-input-3"
                      type="text"
                      className="bx--text-input"
                      placeholder="ex: engajamento"
                      onChange={e => this.setState({ nomePedido: e.target.value })}
                    />
                  </div>
                </div>
              </div>
            </StepCard>
            <div className="bx--col-xs-12  v-md-margin checkout-actions">
              <NavLink to="/carrinho">Voltar para o Carrinho</NavLink>
              <Button
                kind="primary"
                disabled={!(isEdited && logisticsFieldsOk && ((isFinishedDate) || dataPrevisaoOpcional) && !notificationInvalidDate && nomePedido && ((showMotivoPrioridade && motivoPrioridade) || !showMotivoPrioridade))}
                className="btn-secondary-color"
                type="submit"
              >
                Concluir
              </Button>
            </div>
          </form>
        </section>
        {openModal && (
          <Modal
            open={openModal}
            className="confirm-trade"
            onRequestSubmit={() => {
              window.location.href = '/pedidos/agencia'
            }}
            onRequestClose={() => {
              window.location.href = '/pedidos/agencia'
            }}
            modalHeading="Pedido Feito com Sucesso "
            primaryButtonText="Meus Pedidos"
            secondaryButtonText=" Voltar para a Loja "
          >
            {showMotivoPrioridade ? (
              <div className="warning-modal-txt">
                <p>
                  <strong>
                    {`Seu pedido ${numeroPedido} está sob avaliação. Previsão de entrega da arte até dia ${currentDate.format("DD/MM/YYYY")}.`}
                  </strong>
                </p>
                <p className="finalizado-pedido">
                  A qualquer momento você poderá acompanhá-lo clicando no icone
                  {' '}
                  <a className="notifications pointer" href="/pedidos">
                    <i className="assignment icon-orange" />
                  </a>
                  {' '}
                  <br />
                  disponível no canto superior da sua tela. 
                  {' '}
                  <br />
                  {!isDigital ? "* Não contempla tempo de logística e instalação." : ""}
                </p>
              </div>
            ) : (
              <div className="warning-modal-txt">
                <p>
                  <strong>
                    {`Previsão de entrega da arte do seu pedido ${numeroPedido} até dia ${currentDate.format("DD/MM/YYYY")}.`}
                  </strong>
                </p>
                <p className="finalizado-pedido">
                  A qualquer momento você poderá acompanhá-lo clicando no icone
                  {' '}
                  <a className="notifications pointer" href="/pedidos">
                    <i className="assignment icon-orange" />
                  </a>
                  {' '}
                  <br />
                  disponível no canto superior da sua tela. 
                  {' '}
                  <br />
                  {!isDigital ? "* Não contempla tempo de logística e instalação." : ""}
                </p>
              </div>
            )}
          </Modal>
        )}

        {isSaving && <Loading small />}
      </div>
    );
  }
}
export default CheckoutAgencia;



// WEBPACK FOOTER //
// ./src/screens/client/cart/checkoutAgencia.js